import { useLocation } from "react-router-dom";
import AskNaturePulse from "./AskNaturePulse";
import { PERSONAS, personaForPath } from "@/lib/askPersonas";

/** Docket-aware floating assistant — "Ask Nature Pulse ›" on nature pages,
 * "Ask Science Pulse ›" on /science, "Ask Weather Pulse ›" on /weather-pulse,
 * "Ask Farmers Pulse ›" on /farmers and farm sites. History is kept per
 * persona, so each docket's conversation stays separate. */
export default function AskPulse() {
  const { pathname } = useLocation();
  const key = personaForPath(pathname);
  return <AskNaturePulse key={key} persona={PERSONAS[key]} />;
}
